import { Directive, inject } from '@angular/core';
import { PropagationModal } from './propagation-modal';
import { DtcSibling } from '../../../../shared/models/dtc/dtc-sibling';
import { PropagationTargetOption } from '../../../../shared/models/sw-part-number/propagation-target-option';
import { ReviewRequestApiService } from '../../../services/api/review-request-api.service';
import { ReviewRequestPropagationTarget } from '../../../../shared/models/review-requests/review-request-propagation-target';

@Directive()
export abstract class BaseReviewRequestPropagationModal extends PropagationModal {
  protected readonly reviewRequestApi = inject(ReviewRequestApiService);
  protected shouldCreateNewItems = true;

  public override openModal(entityId?: string, dtcSiblings?: DtcSibling[]): void {
    this.entityId = entityId;
    this.businessObject = 'reviewRequest';
    this.propagationTargetOptions = [];
    this.additionalInfoText = 'Note: Only siblings with identical documentation fields are displayed for selection.';
    if (dtcSiblings && !dtcSiblings.every((sibling) => sibling.isEditedEntity)) {
      dtcSiblings.forEach((sibling) => {
        if (sibling.hasIdenticalDocumentationFields) {
          const swPartNumberElement: PropagationTargetOption = {
            id: sibling.id || '',
            number: sibling.swPartNumber || '',
            shouldCreate: !this.shouldCreateNewItems && sibling.isNewItem ? false : true,
            readOnly: sibling.isEditedEntity === true,
            isVisible: true,
            rowVersion: sibling.rowVersion,
            isNewItem: sibling.isNewItem,
          };
          this.propagationTargetOptions?.push(swPartNumberElement);
          if (swPartNumberElement.shouldCreate) {
            this.selectedOptionIds.push(sibling.id || '');
          }
        }
      });
      super.openModal();
    }
  }

  public override closeModal(): void {
    this.entityId = undefined;
    this.businessObject = undefined;
    this.propagationTargetOptions = undefined;
    this.selectedOptionIds = [];
    super.closeModal();
  }

  protected mapSelectedSwPartNumbersToTargets(): ReviewRequestPropagationTarget[] {
    return this.selectedOptionIds.map((id) => ({
      dtcId: id,
      rowVersion: this.propagationTargetOptions?.find((option) => option.id === id)?.rowVersion,
    }));
  }
}
